import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import BlockPage from './components/BlockPage';
import { AppSelectors } from '../../Redux/modules/app/selectors';
import BlockPageForPublicDomains from './components/BlockPageForPublicDomains';

const BlockPageContainer = (props) => {
  if (props.blockReason === 'PUBLIC_DOMAIN') {
    return <BlockPageForPublicDomains {...props} />;
  }

  return <BlockPage {...props} />;
};

BlockPageContainer.propTypes = {
  blockReason: PropTypes.string,
};

const withConnect = connect((state) => {
  return {
    blockReason: AppSelectors.onBoardingBlockReasonSelector(state),
  };
});

export default withConnect(BlockPageContainer);
